import { createApp, Directive } from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store'
import { loadAllPlugins } from './plugins'
import '@/assets/iconfont/iconfont.css'
import '@/styles/index.scss'
import * as directives from '@/directives'
import '@/permission'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import installIcons from '@/icons'
// sentry
import { BrowserTracing } from '@sentry/tracing'
import * as Sentry from '@sentry/vue'

import 'core-js/actual/array/flat-map' // 解决 n.flatMap

const app = createApp(App)

// sentry 配置
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    app,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracePropagationTargets: ['localhost', '', /^\//]
      })
    ],
    environment: process.env.NODE_ENV,
    tracesSampleRate: 1.0
  })
}

// 加载所有插件
loadAllPlugins(app)
// 加载svg图标
installIcons(app)

// 自定义指令
Object.keys(directives).forEach(key => {
  app.directive(key, (directives as { [key: string ]: Directive })[key])
})
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(store).use(router).mount('#app')
